module.exports = __webpack_public_path__ + "static/media/bulb-broken.aa9bcf66.png";